<template>
  <div class="modal_wrap modal_internet_apply_Voucher" :class="{ on: isOpen }">
    <!--'on 추가'-->
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_close" ref="modal_close" @click="$emit('close')">
          <img src="@/assets/front/images/i_x_w.svg" alt="" />
        </div>
        <div class="modal_head">
          <div class="head_title" v-if="from === 'chat'">
            열람권을 사용하여<br />신청서를 열람 하시겠습니까?
          </div>
          <div v-else>
            열람권을 사용하여<br />고객 가입 정보를 열람하시겠습니까?
          </div>
        </div>
        <div class="modal_con">
          <div class="modal_info">
            <div class="con_img">
              <img
                :src="
                  require('@/assets/front/images/new/img_txt_noti_hand.png')
                "
                alt=""
              />
            </div>
            <div class="con_txt" v-if="from === 'chat'">
              신청서 열람 시 열람권 환불이 불가합니다. 설치 장소가 설치
              불가지역은 아닌지, 열람 전 고객님께 확인을 부탁드립니다!
              <br />(열람 후 견적서 보내기를 통해 견적 수정 및 가입신청서를
              추가로 받을 수 있습니다.)
            </div>
            <div class="con_txt" v-else>
              고객 정보 열람 후에는 열람권 환불이 불가합니다.<br />(열람 후
              견적서 보내기를 통해 견적 수정 및 가입신청서를 추가로 받을 수
              있습니다.)
            </div>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap" v-if="shopVouchersCnt > 0">
            <button class="btn" v-on:click="$emit('voucherUse', applyId)">
              <div class="txt_1">1장을 사용하여 열람</div>
              <div class="txt_2">(열람권 {{ shopVouchersCnt }}장 보유)</div>
            </button>
          </div>
          <div class="btn_wrap" v-else>
            <button class="btn bg_grey" v-on:click="$emit('close')">
              <div class="txt_1">열람권이 부족합니다!</div>
              <div class="txt_2">(열람권은 제로노트 사이트에서 충전 가능)</div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    shopVouchersCnt: Number,
    from: {
      type: String,
      default: 'chat',
    },
  },
  data() {
    return {
      isOpen: false,
      applyId: 0,
    };
  },
  name: 'InternetApplyVoucher',
  computed: {},
};
</script>
